import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import BackButton from "../../helpers/BackButton";
import { Breadcrumb, Layout, Menu, Typography, DatePicker } from "antd";
import { Space, Table, Tag, Button } from "antd";
import TokenService from "../../../services/token.service";
import PageWrapper from "../../helpers/PageWrapper";
import streamService from '../../../services/streamService';
import { Input, Form, Select, InputNumber, message } from 'antd';
import Password from 'antd/lib/input/Password';
import { useNavigate } from 'react-router-dom';
import authAxios from "../../../services/api";
import axios from 'axios';
import { useParams } from 'react-router';
const { Title } = Typography;
const styles = { width: '800px', margin: '0 auto' };

const { Option } = Select;
const UpdateAuthPage = () => {
    const [teachers, setTeachers] = useState([]);
    const [groups, setGroups] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [email, setEmail] = useState();
    const [login, setLogin] = useState();
    const [password, setPassword] = useState();
   
    const navigate = useNavigate();






  const onEmailChange = (e) => {
    setEmail(e.target.value)
    // console.log(`selected name ${e.target.value}`);
  };
  const onLoginChange = (e) => {
    setLogin(e.target.value)
    // console.log(`selected name ${e.target.value}`);
  };
  const onPasswordChange = (e) => {
    setPassword(e.target.value)
    // console.log(`selected name ${e.target.value}`);
  };
 
    
  
  const email1 = email
  const login1 = login
  const password1 = password

 
  

  const handleSubmit = () => {
    
    const data = {
        email: email1,
        username: login1,
        password: password1,
      };

      authAxios.put(`http://85.159.27.198:8080/abitur/api/auth/update?userId=${TokenService.getLocalUserId()}`, data,  {
      headers: {
        'Authorization': 'Bearer ' + TokenService.getLocalAccessToken()
      }
    })
      .then(res => {
        console.log(res);
        console.log(res.data);
        // window.location.reload();
        localStorage.removeItem("user");
      window.location.reload();
      message.success('Данные изменены', 10);
      navigate(`/login-page`);
      }).catch((error) =>  message.error(error, 10));
      
      
  }

 
    return (
      <PageWrapper>
        
        <Typography.Title level={1}>Изменить данные авторизации</Typography.Title>
        <section>
        <Form  onFinish={handleSubmit} >
      <Form.Item
        label="Email"
        rules={[
          {
            type: 'email',
          },
        ]}
      >
        <Input placeholder="Введите почту" name="email"
            value={email}
            onChange={onEmailChange} type =  'email' />
      </Form.Item>
      <Form.Item
        label="Логин"

      >
        <Input placeholder="Введите новый логин" name="login"
            value={login}
            onChange={onLoginChange} 
                  
                />
      </Form.Item>
      <Form.Item label="Пароль">
      <Password placeholder="Введите новый пароль" name="password"
            value={password}
            onChange={onPasswordChange} />
      </Form.Item>
      
      <Form.Item
       
      >
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
        {/* <Space size={20} direction={'vertical'}>
        <Input placeholder="Введите почту" name="email"
            value={email}
            onChange={onEmailChange} />
        <Space size={20} direction={'vertical'}></Space>
        <Input placeholder="Введите новый логин" name="login"
            value={login}
            onChange={onLoginChange} 
                  type =  'email'
                />
        <Space size={20} direction={'vertical'}></Space>
        <Password placeholder="Введите новый пароль" name="password"
            value={password}
            onChange={onPasswordChange} />
        <Space size={20} direction={'vertical'}></Space>
        
        </Space>
        <br />
        <br />
        <Space size={20}>
          <Button type={'default'} onClick={handleSubmit}>
            Изменить
          </Button>

          
        </Space> */}
      </section>
      </PageWrapper>



    )
  }


export default UpdateAuthPage;